import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { withTranslation } from 'react-i18next';
import Lightbox from '@seafile/react-image-lightbox';
import { Utils } from '../../utils/utils';
import InlineElementUtils from '../editor-utils/inline-element-utils';
import EditorBuilder from '../editor-builder';
import '@seafile/react-image-lightbox/style.css';

var Image = /*#__PURE__*/function (_React$Component) {
  _inherits(Image, _React$Component);

  var _super = _createSuper(Image);

  function Image(props) {
    var _this;

    _classCallCheck(this, Image);

    _this = _super.call(this, props);

    _this.startMove = function (e) {
      e.stopPropagation();

      _this.setState({
        isResizing: true
      });

      window.addEventListener('mousemove', _this.handleMove);
      window.addEventListener('mouseup', _this.stopMove);
    };

    _this.stopMove = function (e) {
      e.stopPropagation();
      e.preventDefault();
      window.removeEventListener('mousemove', _this.handleMove);
      var node = _this.props.node;

      _this.inlineElementUtils.adjustImageSize({
        width: _this.state.width,
        src: node.data.src
      });

      _this.setState({
        isResizing: false
      });

      window.removeEventListener('mouseup', _this.stopMove);
    };

    _this.handleMove = function (e) {
      e.stopPropagation();
      e.preventDefault();
      var changeX;
      changeX = e.clientX - _this.refs.resizer.getBoundingClientRect().left - 5;
      var imageWidth = _this.refs.image.width + changeX;

      if (imageWidth >= _this.editor.offsetWidth) {
        return;
      }

      if (imageWidth < 20) {
        return;
      }

      _this.setState({
        width: imageWidth
      });
    };

    _this.setFullScreen = function (event) {
      event.stopPropagation();
      var src = _this.props.node.data.src;

      _this.toggleBigImage(event, src);
    };

    _this.toggleBigImage = function (event, src) {
      event.preventDefault();

      _this.setState({
        isShowBigImage: !_this.state.isShowBigImage
      });

      _this.imgSrc = src;
    };

    _this.renderImagePreviewer = function () {
      return /*#__PURE__*/React.createElement(ImagePreviewer, {
        imageUrl: _this.imgSrc,
        toggleImagePreviewer: _this.toggleBigImage
      });
    };

    _this.state = {
      width: null,
      isResizing: false,
      isShowBigImage: false
    };
    var editor = EditorBuilder.getEditor();
    _this.inlineElementUtils = new InlineElementUtils(editor);
    return _this;
  }

  _createClass(Image, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.editor = document.querySelector('.editor-component');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.refs.resizer = null;
      this.refs.image = null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          attributes = _this$props.attributes,
          node = _this$props.node,
          isSelected = _this$props.isSelected,
          children = _this$props.children;
      var isResizing = this.state.isResizing;
      var data = node.data;
      var src = data.src;

      if (/^\.\.\/*/.test(src) || /^\.\/*/.test(src)) {
        var editor = EditorBuilder.getEditor();
        var _editor$editorApi = editor.editorApi,
            filePath = _editor$editorApi.filePath,
            serviceUrl = _editor$editorApi.serviceUrl,
            repoID = _editor$editorApi.repoID;
        var originalPath = filePath.slice(0, filePath.lastIndexOf('/')) + '/' + src;
        src = serviceUrl + '/lib/' + repoID + '/file/' + Utils.pathNormalize(originalPath) + '?raw=1';
      }

      var dom = /*#__PURE__*/React.createElement("span", Object.assign({
        className: "seafile-ed-image"
      }, attributes), isSelected || isResizing ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", {
        className: "seafile-ed-image-inResizing",
        draggable: false,
        src: src,
        width: this.state.width || data.width,
        alt: ' ',
        ref: "image"
      }), this.state.isResizing ? /*#__PURE__*/React.createElement("span", {
        contentEditable: false,
        className: "image-size"
      }, /*#__PURE__*/React.createElement("span", null, this.props.t('width'), ':', parseInt(this.state.width || this.refs.image.clientWidth)), /*#__PURE__*/React.createElement("span", null, "\xA0\xA0"), /*#__PURE__*/React.createElement("span", null, this.props.t('height'), ':', this.refs.image.clientHeight)) : null, /*#__PURE__*/React.createElement("span", {
        ref: "resizer",
        onMouseDown: this.startMove,
        className: 'image-resizer'
      }), isSelected && /*#__PURE__*/React.createElement("span", {
        contentEditable: false,
        onClick: this.setFullScreen,
        className: "image-full-button"
      }, /*#__PURE__*/React.createElement("i", {
        className: 'iconfont icon-fullscreen'
      }), /*#__PURE__*/React.createElement("span", {
        className: 'image-tooltip'
      }, this.props.t('Full_screen')))) : /*#__PURE__*/React.createElement("img", {
        width: data.width || '',
        draggable: false,
        src: src,
        alt: ' ',
        ref: "image"
      }), children, this.state.isShowBigImage && this.renderImagePreviewer());
      return src ? dom : /*#__PURE__*/React.createElement("span", attributes, "Loading...");
    }
  }]);

  return Image;
}(React.Component);

var ImagePreviewer = /*#__PURE__*/function (_React$Component2) {
  _inherits(ImagePreviewer, _React$Component2);

  var _super2 = _createSuper(ImagePreviewer);

  function ImagePreviewer(props) {
    var _this2;

    _classCallCheck(this, ImagePreviewer);

    _this2 = _super2.call(this, props);

    _this2.getImageNodes = function (nodes) {
      var nodeIndex = 0;
      var list = [];

      while (nodes && nodeIndex <= nodes.length - 1) {
        var currentNode = nodes[nodeIndex];

        if (currentNode.type === 'image') {
          currentNode.data.src && list.push(currentNode.data.src);
        } else {
          list.push.apply(list, _toConsumableArray(_this2.getImageNodes(currentNode.children)));
        }

        nodeIndex++;
      }

      return list;
    };

    _this2.moveToPrevImage = function () {
      _this2.setState(function (prevState) {
        return {
          imageIndex: (prevState.imageIndex + _this2.images.length - 1) % _this2.images.length
        };
      });
    };

    _this2.moveToNextImage = function () {
      _this2.setState(function (prevState) {
        return {
          imageIndex: (prevState.imageIndex + 1) % _this2.images.length
        };
      });
    };

    var editor = EditorBuilder.getEditor();
    _this2.images = _this2.getImageNodes(editor.children);
    _this2.state = {
      imageIndex: _this2.images.findIndex(function (item) {
        return item === props.imageUrl;
      })
    };
    return _this2;
  }

  _createClass(ImagePreviewer, [{
    key: "render",
    value: function render() {
      var imageIndex = this.state.imageIndex;
      var imageItemsLength = this.images.length;
      var mainSrc = this.images[imageIndex];
      var imageTitle = '';

      try {
        imageTitle = mainSrc ? decodeURI(mainSrc.slice(mainSrc.lastIndexOf('/') + 1)) : '';
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }

      var imageTitleEl = /*#__PURE__*/React.createElement("span", {
        className: "d-flex"
      }, /*#__PURE__*/React.createElement("span", {
        className: "text-truncate"
      }, imageTitle), /*#__PURE__*/React.createElement("span", {
        className: "flex-shrink-0"
      }, "(", imageIndex + 1, "/", this.images.length, ")"));
      return /*#__PURE__*/React.createElement(Lightbox, {
        wrapperClassName: "sf-editor-image-previewer",
        imageTitle: imageTitleEl,
        mainSrc: mainSrc,
        toolbarButtons: [],
        nextSrc: this.images[(imageIndex + 1) % imageItemsLength],
        prevSrc: this.images[(imageIndex + imageItemsLength - 1) % imageItemsLength],
        onCloseRequest: this.props.toggleImagePreviewer,
        onMovePrevRequest: this.moveToPrevImage,
        onMoveNextRequest: this.moveToNextImage,
        imagePadding: 70,
        reactModalStyle: {
          overlay: {
            zIndex: 1051
          }
        }
      });
    }
  }]);

  return ImagePreviewer;
}(React.Component);

export default withTranslation('seafile-editor')(Image);